import { useSelector, useDispatch } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import Link from "next/link";
import clsx from "clsx";
import { fetchSections } from "/redux/action-creaters/sections";
import { fetchBrands } from "/redux/action-creaters/brands";
import { safeLocalStorage } from "~/utils/safeStorage";
import Icon from "../../../common/icon";
import styles from "./index.module.scss";

export default function TopSections() {
  const { sections } = useSelector((state) => state.sections);
  const { items } = useSelector((state) => state.brands);
  const sectionsMap = sections ?? {};
  const brandsList = Array.isArray(items) ? items : [];
  const [filterUrl, setFilterUrl] = useState("");

  const [rootId, setRootId] = useState(-1);
  const dispatch = useDispatch();

  const sectionsTree = useMemo(() => {
    // eslint-disable-next-line no-use-before-define
    return getSectionsTree(sectionsMap);
  }, [sectionsMap]);

  useEffect(() => {
    if (Object.keys(sectionsMap).length === 0) {
      dispatch(fetchSections());
    }
    if (brandsList.length === 0) {
      dispatch(fetchBrands());
    }
  }, []);

  useEffect(() => {
    setFilterUrl(safeLocalStorage.getItem("filterUrl") ?? "");
  });

  return (
    <div className={styles.TopSections}>
      <div className={styles.ChildSections}>
        {rootId === -1 && (
          <div className={styles.Sections}>
            {sectionsTree.map((section) => (
              <Link
                href={
                  section.SECTION_PAGE_URL +
                  (section.CHILD?.length > 0 ? "" : filterUrl)
                }
                key={section.ID}
              >
                <a className={styles.Section}>
                  <div>
                    <img
                      src={section.DETAIL_PICTURE_PATH}
                      alt={section.NAME}
                      title={section.NAME}
                    />
                  </div>
                  <span>{section.NAME}</span>
                </a>
              </Link>
            ))}
          </div>
        )}
        {sectionsTree.length > 0 && sectionsTree[rootId]?.NAME && (
          <>
            <div className={styles.Title}>{sectionsTree[rootId].NAME}</div>
            <div className={styles.Sections}>
              {sectionsTree[rootId].CHILD.map((section) => (
                <Link
                  href={
                    section.SECTION_PAGE_URL +
                    (section.CHILD?.length > 0 ? "" : filterUrl)
                  }
                  key={section.ID}
                >
                  <a className={styles.Section}>
                    <div>
                      <img
                        src={section.DETAIL_PICTURE_PATH}
                        alt={section.NAME}
                        title={section.NAME}
                      />
                    </div>
                    <span>{section.NAME}</span>
                  </a>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
      <div className={styles.RootSections}>
        <ul>
          {sectionsTree.map((section, id) => (
            <li
              key={section.ID}
              onClick={() => {
                if (section.CHILD.length > 0) setRootId(id);
              }}
              className={clsx(id === rootId && styles.Selected)}
            >
              {section.CHILD.length === 0 ? (
                <Link href={section.SECTION_PAGE_URL + filterUrl}>
                  <a>{section.NAME}</a>
                </Link>
              ) : (
                <>
                  <Icon
                    id="arrow"
                    width={8}
                    height={14}
                    fill={id === rootId ? "#1247a5" : "#333"}
                  />
                  {section.NAME}
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

const sectionssss = [
  "/catalog/farkopy/",
  // "/catalog/vstavki_pod_kvadrat/",
  "/catalog/elektrika_farkopov/",
  // "/catalog/aksessuary_i_zapchasti/",
  // "/catalog/aksessuary_i_zapchasti/smazki_i_zashchitnye_sredstva/",
  // "/catalog/aksessuary_i_zapchasti/rozetki_i_vilki/",
  // "/catalog/aksessuary_i_zapchasti/kolpachki/",
  // "/catalog/aksessuary_i_zapchasti/zaglushki/",
];

function getSectionsTree(sections = {}, parent = null) {
  return Object.values(sections ?? {})
    .filter((section) => {
      return (
        +section.IBLOCK_SECTION_ID === +parent &&
        sectionssss.includes(section.SECTION_PAGE_URL)
      );
    })
    .map((section) => {
      return {
        ...section,
        CHILD:
          section.HAS_CHILDS === "Y"
            ? getSectionsTree(sections, section.ID)
            : [],
      };
    })
    .sort((a, b) => a.SORT - b.SORT);
}
